<template>
  <div class="subscription-flow" v-if="!asyncLoading">
    <!--We use v-show and not v-if because the credit-card component cannot be re-rendered-->
    <!--The fields in it are mounted by payme making rerendering heavy and destroying previous context-->
    <template v-if="onCreditCardStep">
      <credit-card v-show="onCreditCardStep"/>
    </template>
    <template v-else>
      <done v-show="onDone"/>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CreditCard from './pages/CreditCard.vue';
import Done from './pages/Done.vue';
import Segment from '../../../../Segment';
import router from '../../../../router';

export default {
  name: 'SubscriptionFlow',
  components: {
    CreditCard,
    Done,
  },
  data() {
    return {
      asyncLoading: true,
    };
  },
  async created() {
    Segment.trackUserGot('SubscriptionEntered');
    await this.init();
    this.asyncLoading = false;
  },
  computed: {
    ...mapGetters('subscription', ['onCreditCardStep', 'onDone']),
  },
  methods: {
    ...mapActions('subscription', ['init']),
    moveBackToCashflow() {
      Segment.trackUserInteraction('SubscriptionMoveBackToCashflow');
      router.push({ path: '/home' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../scss/mixins';

  .subscription-flow {
  }
</style>
